/* ==========================================================================
   Synterra Labs Quiz
   - Self-contained, vanilla JS, no jQuery.
   - Edit QUIZ_CONFIG below to change questions, products, copy, scoring.
   - State persists in sessionStorage so a refresh does not lose progress.
   ========================================================================== */

(function () {
  'use strict';

  if (window.__synterraQuizReady) return;
  window.__synterraQuizReady = true;

  /* ==========================================================================
     QUIZ CONFIG — pas alles hier aan
     ========================================================================== */
  const QUIZ_CONFIG = {
    // Hoeveel vragen totaal (moet overeenkomen met questions.length).
    progressLabel: '{current} / {total}',

    // Start scherm
    start: {
      titlePart1: 'Ontdek Jouw',
      titlePart2: 'Perfecte Stack',
      intro: 'Beantwoord 10 vragen en ontvang een gepersonaliseerde aanbeveling op basis van jouw doelen, leefstijl en behoeften.',
      cta: 'Start de Quiz'
    },

    // Loading scherm (na laatste vraag, voor result)
    loading: {
      duration: 1600, // ms
      text: 'We berekenen jouw perfecte stack op basis van jouw antwoorden...'
    },

    // Result scherm copy
    result: {
      eyebrow: 'Jouw resultaat',
      titlePrefix: 'Jouw perfecte',
      titleHighlight: 'stack',
      intro: 'Op basis van jouw doelen en leefstijl raden we het volgende aan:',
      primaryCtaFallback: 'Bestel nu',
      secondaryCta: 'Bekijk product',
      restartLabel: 'Quiz opnieuw doen'
    },

    nextLabel: 'Volgende',
    nextLabelFinal: 'Resultaat tonen',
    multiHint: 'Meerdere antwoorden mogelijk',

    // Productdefinities — koppel aan Shopify product handles
    // Image: laat leeg om Shopify featured image te fetchen via /products/HANDLE.js
    products: {
      energy: {
        title: 'Cellular Energy',
        handle: 'cellular-energy',
        image: '',
        tagline: 'Sustained energie en cellulaire vitaliteit voor de meest veeleisende dagen.',
        bullets: [
          'Ubiquinol CoQ10',
          'PQQ',
          'Calcium Alpha-Ketoglutaraat (Ca-AKG)',
          'Acetyl-L-Carnitine (ALCAR)',
          'Astaxanthin'
        ],
        cta: 'Bestel Cellular Energy',
        color: '#2F8FEA'
      },
      focus: {
        title: 'Brain Focus',
        handle: 'brain-focus',
        image: '',
        tagline: 'Mentale helderheid, focus en geheugen — voor wie elke dag piekprestaties levert.',
        bullets: [
          'Magnesium L-Threonaat',
          "Lion's Mane Extract",
          'Citicoline',
          'Rhodiola Rosea Extract'
        ],
        cta: 'Bestel Brain Focus',
        color: '#8F5FD7'
      },
      longevity: {
        title: 'Longevity Complex',
        handle: 'longevity-complex',
        image: '',
        tagline: 'Geavanceerde anti-aging formule gericht op cellulair herstel en gezond ouder worden.',
        bullets: [
          'Nicotinamide Riboside (NR)',
          'Trans-Resveratrol',
          'Calcium Alpha-Ketoglutarate (Ca-AKG)',
          'Pyrroloquinoline Quinone (PQQ)',
          'Trimethylglycine (TMG)'
        ],
        cta: 'Bestel Longevity Complex',
        color: '#3E8B67'
      },
      metabolic: {
        title: 'Metabolic Optimization',
        handle: 'metabolic-optimization',
        image: '',
        tagline: 'Optimaal metabolisme, stabiele glucose en effectieve vetverbranding.',
        bullets: [
          'Berberine HCl',
          'Myo-Inositol',
          'Alpha Lipoic Acid',
          'Chroom picolinaat'
        ],
        cta: 'Bestel Metabolic Optimization',
        color: '#F28A22'
      }
    },

    // De vragen. Elke `option` heeft een `scores` object dat punten toekent
    // aan tags. Het tag met de hoogste score = aanbevolen product.
    // Tags moeten overeenkomen met de product keys hierboven.
    questions: [
      {
        id: 'goal',
        question: 'Wat is op dit moment je belangrijkste gezondheidsdoel?',
        type: 'single',
        options: [
          { text: 'Meer energie en minder vermoeidheid overdag', scores: { energy: 3 } },
          { text: 'Scherper denken en betere concentratie', scores: { focus: 3 } },
          { text: 'Gezond ouder worden en cellulair herstel', scores: { longevity: 3 } },
          { text: 'Gewichtsbeheer en stabieler metabolisme', scores: { metabolic: 3 } }
        ]
      },
      {
        id: 'energy-level',
        question: 'Hoe zou je je energieniveau de afgelopen weken omschrijven?',
        type: 'single',
        options: [
          { text: 'Vaak vermoeid, ook na voldoende slaap', scores: { energy: 3 } },
          { text: 'Middagdip met afnemende focus', scores: { energy: 2, metabolic: 1 } },
          { text: 'Wisselend — soms top, soms platgeslagen', scores: { energy: 1, focus: 1 } },
          { text: 'Stabiel en goed', scores: { longevity: 1 } }
        ]
      },
      {
        id: 'cognitive',
        question: 'Hoe ervaar je je mentale helderheid en focus?',
        type: 'single',
        options: [
          { text: 'Brain fog, snel afgeleid, vergeetachtig', scores: { focus: 3 } },
          { text: 'Lastig om langer aan een stuk te focussen', scores: { focus: 2 } },
          { text: 'Goed in de ochtend, minder in de middag', scores: { focus: 1, energy: 1 } },
          { text: 'Helder en scherp', scores: { longevity: 1 } }
        ]
      },
      {
        id: 'sleep',
        question: 'Hoeveel uur slaap krijg je gemiddeld per nacht?',
        type: 'single',
        options: [
          { text: 'Minder dan 6 uur', scores: { energy: 2, longevity: 2 } },
          { text: '6 - 7 uur', scores: { energy: 1, longevity: 1 } },
          { text: '7 - 8 uur', scores: { focus: 1 } },
          { text: 'Meer dan 8 uur — maar nog vermoeid', scores: { energy: 2, metabolic: 1 } }
        ]
      },
      {
        id: 'activity',
        question: 'Hoe vaak ben je fysiek actief per week?',
        type: 'single',
        options: [
          { text: 'Bijna nooit', scores: { metabolic: 2, energy: 1 } },
          { text: '1 tot 2 keer (wandelen, light cardio)', scores: { metabolic: 1, energy: 1 } },
          { text: '3 tot 4 keer (kracht of cardio)', scores: { longevity: 1, energy: 1 } },
          { text: '5 of meer keer — intensieve training', scores: { longevity: 2, energy: 1 } }
        ]
      },
      {
        id: 'age',
        question: 'In welke leeftijdscategorie val je?',
        type: 'single',
        options: [
          { text: '18 - 30', scores: { focus: 1, energy: 1 } },
          { text: '31 - 45', scores: { focus: 1, longevity: 1 } },
          { text: '46 - 60', scores: { longevity: 2, metabolic: 1 } },
          { text: '60+', scores: { longevity: 3, metabolic: 1 } }
        ]
      },
      {
        id: 'stress',
        question: 'Hoe omschrijf je je gemiddelde stressniveau?',
        type: 'single',
        options: [
          { text: 'Vaak gestrest, slecht inslapen', scores: { focus: 2, longevity: 1 } },
          { text: 'Regelmatig spanning, met name op werk', scores: { focus: 2, energy: 1 } },
          { text: 'Soms wat spanning, herstel snel', scores: { focus: 1 } },
          { text: 'Meestal kalm en ontspannen', scores: { longevity: 1 } }
        ]
      },
      {
        id: 'diet',
        question: 'Hoe ziet je eetpatroon er op een gemiddelde dag uit?',
        type: 'single',
        options: [
          { text: 'Onregelmatig, veel bewerkte voeding of suiker', scores: { metabolic: 3 } },
          { text: 'Wisselend — soms gezond, soms minder', scores: { metabolic: 1, energy: 1 } },
          { text: 'Vrij gebalanceerd met groente en eiwit', scores: { longevity: 1, focus: 1 } },
          { text: 'Streng en geoptimaliseerd (keto / mediterraan / etc.)', scores: { longevity: 2 } }
        ]
      },
      {
        id: 'challenge',
        question: 'Wat is op dit moment je grootste uitdaging? (Kies één)',
        type: 'single',
        options: [
          { text: 'Afvallen of vetverbranding', scores: { metabolic: 3 } },
          { text: 'Mentale prestaties (werk of studie)', scores: { focus: 3 } },
          { text: 'Herstel na intensieve trainingen', scores: { energy: 2, longevity: 1 } },
          { text: 'Anti-aging en vitaliteit op de lange termijn', scores: { longevity: 3 } }
        ]
      },
      {
        id: 'experience',
        question: 'Hoe is je ervaring met supplementen?',
        type: 'single',
        options: [
          { text: 'Geen ervaring — wil voorzichtig beginnen', scores: { energy: 1 } },
          { text: 'Basics: multivitamine, vitamine D, omega 3', scores: { energy: 1, focus: 1, longevity: 1, metabolic: 1 } },
          { text: 'Ervaren — bouw doelgericht een stack op', scores: { focus: 1, longevity: 1 } },
          { text: 'Geavanceerd — optimaliseer voor performance en longevity', scores: { longevity: 2, focus: 1 } }
        ]
      }
    ]
  };

  /* ==========================================================================
     Helpers
     ========================================================================== */
  const STORAGE_KEY = 'synterra-quiz-state';

  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $$(sel, ctx) { return Array.from((ctx || document).querySelectorAll(sel)); }
  function escapeHtml(str) {
    if (str == null) return '';
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }
  function loadState() {
    try {
      const raw = sessionStorage.getItem(STORAGE_KEY);
      return raw ? JSON.parse(raw) : null;
    } catch (e) { return null; }
  }
  function saveState(state) {
    try { sessionStorage.setItem(STORAGE_KEY, JSON.stringify(state)); }
    catch (e) { /* ignore */ }
  }
  function clearState() {
    try { sessionStorage.removeItem(STORAGE_KEY); } catch (e) { /* ignore */ }
  }

  /* ==========================================================================
     Main quiz class
     ========================================================================== */
  class SynterraQuiz {
    constructor(root, config) {
      this.root = root;
      this.config = config;
      this.questions = config.questions;
      this.total = this.questions.length;

      const persisted = loadState();
      this.state = persisted || {
        screen: 'start',      // 'start' | 'question' | 'loading' | 'result'
        currentIndex: 0,
        answers: {}           // { questionId: [optionIndex, ...] }
      };

      // DOM refs
      // Render-doel = de schermen-container, NIET .synterra-quiz__main zelf,
      // anders wist innerHTML de achtergrond-afbeelding + overlay (siblings).
      this.$main = $('[data-quiz-screens]', root) || $('.synterra-quiz__main', root);
      this.$back = $('.synterra-quiz__back', root);
      this.$progress = $('.synterra-quiz__progress', root);
      this.$progressBar = $('.synterra-quiz__progress-bar-fill', root);

      // Add body class to suppress site header/footer
      document.body.classList.add('has-synterra-quiz-fullscreen');

      // Listeners
      this.$back.addEventListener('click', () => this.goBack());

      // Render initial
      this.render();
    }

    persist() { saveState(this.state); }

    setScreen(name) {
      this.state.screen = name;
      this.root.setAttribute('data-screen', name);
      this.persist();
      this.render();
    }

    /* ---------------------------- Rendering --------------------------------- */
    render() {
      this.updateHeader();
      switch (this.state.screen) {
        case 'start':    this.renderStart(); break;
        case 'question': this.renderQuestion(); break;
        case 'loading':  this.renderLoading(); break;
        case 'result':   this.renderResult(); break;
      }
    }

    updateHeader() {
      const s = this.state;
      // Back visibility
      if (s.screen === 'start' || s.screen === 'loading') {
        this.$back.setAttribute('hidden', '');
      } else {
        this.$back.removeAttribute('hidden');
      }

      // Progress label
      let current = 1;
      let total = this.total;
      if (s.screen === 'start') current = 1;
      else if (s.screen === 'question') current = s.currentIndex + 1;
      else current = total;

      this.$progress.innerHTML = (this.config.progressLabel || '{current} / {total}')
        .replace('{current}', '<strong>' + current + '</strong>')
        .replace('{total}', total);

      // Progress bar
      let pct = 0;
      if (s.screen === 'start') pct = 0;
      else if (s.screen === 'question') pct = ((s.currentIndex) / total) * 100;
      else pct = 100;
      this.$progressBar.style.width = pct + '%';
    }

    renderStart() {
      const c = this.config.start;
      this.$main.innerHTML = `
        <div class="synterra-quiz__screen synterra-quiz__start">
          <h1 class="synterra-quiz__start-title">
            ${escapeHtml(c.titlePart1)}
            <em>${escapeHtml(c.titlePart2)}</em>
          </h1>
          <p class="synterra-quiz__start-intro">${escapeHtml(c.intro)}</p>
          <button type="button" class="synterra-quiz__btn" data-action="start">${escapeHtml(c.cta)}</button>
        </div>
      `;
      $('[data-action="start"]', this.$main).addEventListener('click', () => {
        this.state.currentIndex = 0;
        this.setScreen('question');
      });
    }

    renderQuestion() {
      const q = this.questions[this.state.currentIndex];
      const selected = this.state.answers[q.id] || [];
      const isMulti = q.type === 'multi';
      const isFinal = this.state.currentIndex === this.total - 1;

      this.$main.innerHTML = `
        <div class="synterra-quiz__screen">
          <p class="synterra-quiz__question-eyebrow">Vraag ${this.state.currentIndex + 1} van ${this.total}</p>
          <h2 class="synterra-quiz__question">${escapeHtml(q.question)}</h2>
          ${isMulti ? `<p class="synterra-quiz__question-hint">${escapeHtml(this.config.multiHint || '')}</p>` : '<div style="height: 1.2rem"></div>'}
          <div class="synterra-quiz__options" role="${isMulti ? 'group' : 'radiogroup'}">
            ${q.options.map((opt, idx) => `
              <button type="button"
                      class="synterra-quiz__option${selected.indexOf(idx) >= 0 ? ' is-selected' : ''}"
                      data-multi="${isMulti}"
                      data-idx="${idx}"
                      role="${isMulti ? 'checkbox' : 'radio'}"
                      aria-checked="${selected.indexOf(idx) >= 0}">
                <span class="synterra-quiz__option-mark" aria-hidden="true"></span>
                <span class="synterra-quiz__option-text">${escapeHtml(opt.text)}</span>
              </button>
            `).join('')}
          </div>
          <div class="synterra-quiz__actions">
            <button type="button"
                    class="synterra-quiz__btn"
                    data-action="next"
                    ${selected.length === 0 ? 'disabled' : ''}>
              ${escapeHtml(isFinal ? this.config.nextLabelFinal : this.config.nextLabel)}
            </button>
          </div>
        </div>
      `;

      // Option clicks
      $$('.synterra-quiz__option', this.$main).forEach(btn => {
        btn.addEventListener('click', () => this.toggleOption(parseInt(btn.dataset.idx, 10), isMulti));
      });
      // Next
      $('[data-action="next"]', this.$main).addEventListener('click', () => this.next());
    }

    toggleOption(idx, isMulti) {
      const q = this.questions[this.state.currentIndex];
      let current = this.state.answers[q.id] || [];
      if (isMulti) {
        const pos = current.indexOf(idx);
        if (pos >= 0) current.splice(pos, 1);
        else current.push(idx);
      } else {
        current = [idx];
      }
      this.state.answers[q.id] = current;
      this.persist();
      this.renderQuestion();
    }

    next() {
      if (this.state.currentIndex < this.total - 1) {
        this.state.currentIndex += 1;
        this.setScreen('question');
      } else {
        this.setScreen('loading');
      }
    }

    goBack() {
      const s = this.state;
      if (s.screen === 'question') {
        if (s.currentIndex === 0) {
          this.setScreen('start');
        } else {
          s.currentIndex -= 1;
          this.setScreen('question');
        }
      } else if (s.screen === 'result') {
        s.currentIndex = this.total - 1;
        this.setScreen('question');
      }
    }

    renderLoading() {
      const c = this.config.loading;
      this.$main.innerHTML = `
        <div class="synterra-quiz__screen synterra-quiz__loading">
          <div class="synterra-quiz__spinner" aria-hidden="true"></div>
          <p class="synterra-quiz__loading-text">${escapeHtml(c.text)}</p>
        </div>
      `;
      setTimeout(() => this.setScreen('result'), c.duration);
    }

    /* ---------------------------- Result & scoring -------------------------- */
    computeResult() {
      const scores = {};
      Object.keys(this.config.products).forEach(k => { scores[k] = 0; });

      this.questions.forEach(q => {
        const selectedIdxs = this.state.answers[q.id] || [];
        selectedIdxs.forEach(idx => {
          const opt = q.options[idx];
          if (opt && opt.scores) {
            Object.keys(opt.scores).forEach(tag => {
              scores[tag] = (scores[tag] || 0) + opt.scores[tag];
            });
          }
        });
      });

      // Find highest score
      let topTag = null, topScore = -1;
      Object.keys(scores).forEach(tag => {
        if (scores[tag] > topScore) {
          topScore = scores[tag];
          topTag = tag;
        }
      });

      return { tag: topTag, scores: scores };
    }

    async renderResult() {
      const { tag, scores } = this.computeResult();
      const product = this.config.products[tag] || Object.values(this.config.products)[0];

      // Try to fetch Shopify product image if no image URL set
      let imgSrc = product.image;
      if (!imgSrc && product.handle) {
        try {
          const res = await fetch('/products/' + product.handle + '.js');
          if (res.ok) {
            const data = await res.json();
            imgSrc = data.featured_image;
          }
        } catch (e) { /* product may not exist yet */ }
      }

      const r = this.config.result;
      const productUrl = product.handle ? '/products/' + product.handle : '#';

      this.$main.innerHTML = `
        <div class="synterra-quiz__screen synterra-quiz__result">
          <p class="synterra-quiz__result-eyebrow">${escapeHtml(r.eyebrow)}</p>
          <h2 class="synterra-quiz__result-title">
            ${escapeHtml(r.titlePrefix)} <em>${escapeHtml(r.titleHighlight)}</em>
          </h2>
          <p class="synterra-quiz__result-intro">${escapeHtml(r.intro)}</p>

          <div class="synterra-quiz__product-card" style="--syq-accent: ${product.color || '#8A7547'};">
            <div class="synterra-quiz__product-image">
              ${imgSrc
                ? `<img src="${escapeHtml(imgSrc)}" alt="${escapeHtml(product.title)}" loading="lazy">`
                : `<div class="synterra-quiz__product-placeholder">${escapeHtml(product.title)}</div>`
              }
            </div>
            <div class="synterra-quiz__product-info">
              <h3 class="synterra-quiz__product-name">${escapeHtml(product.title)}</h3>
              <p class="synterra-quiz__product-tagline">${escapeHtml(product.tagline)}</p>
              <ul class="synterra-quiz__product-bullets">
                ${(product.bullets || []).map(b => `<li>${escapeHtml(b)}</li>`).join('')}
              </ul>
              <div class="synterra-quiz__product-actions">
                <a class="synterra-quiz__btn" href="${escapeHtml(productUrl)}">${escapeHtml(product.cta || r.primaryCtaFallback)}</a>
                <a class="synterra-quiz__btn synterra-quiz__btn--ghost" href="${escapeHtml(productUrl)}">${escapeHtml(r.secondaryCta)}</a>
              </div>
            </div>
          </div>

          <div class="synterra-quiz__result-footer">
            <button type="button" class="synterra-quiz__restart" data-action="restart">${escapeHtml(r.restartLabel)}</button>
          </div>
        </div>
      `;

      $('[data-action="restart"]', this.$main).addEventListener('click', () => this.restart());
    }

    restart() {
      clearState();
      this.state = { screen: 'start', currentIndex: 0, answers: {} };
      this.setScreen('start');
    }
  }

  /* ==========================================================================
     Boot
     ========================================================================== */
  function init() {
    const root = document.querySelector('[data-synterra-quiz]');
    if (!root) return;
    new SynterraQuiz(root, QUIZ_CONFIG);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
